import qs from 'querystring';
import { useEffect } from 'react';

const params = {
  client_id: process.env.REACT_APP_OKTA_OAUTH_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_OKTA_REDIRECT_URL,
  scope: 'profile openid email',
  response_type: 'code',
  state: 'OR',
};
const loginUrl = process.env.REACT_APP_OKTA_URL + '?' + qs.encode(params);

export default function LoginPage() {
  useEffect(() => {
    window.location.href = loginUrl;
  }, []);

  return (
    <section className='tw-bg-white dark:tw-bg-gray-900 tw-min-h-screen' />
  );
}
